module.exports = __webpack_public_path__ + "static/media/68.34dce1da.jpg";